import script from "./HeaderLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderLayout.vue?vue&type=script&setup=true&lang=js"

import "./HeaderLayout.vue?vue&type=style&index=0&id=5f79c9ed&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f79c9ed"]])

export default __exports__